import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useQueryString } from "./useQueryString";
import { useQuery } from "@tanstack/react-query";
import { Spinner } from "@adfenix/alexandria";
import { getHqInfo } from "api/services/programService";

export const useV4OrderRedirect = (pageMode: "customer" | "ap") => {
  const navigate = useNavigate();
  const { programInstanceId } = useQueryString();

  const { data } = useQuery(
    ["hq-info", programInstanceId],
    () => getHqInfo(programInstanceId!),
    {
      enabled: !!programInstanceId
    }
  );

  useEffect(() => {
    if (!data) {
      return;
    }

    const params = new URLSearchParams(window.location.search);
    params.delete("domain");

    const url =
      pageMode === "ap"
        ? `/hq/${data.hqId}/ap-order`
        : `/customer/hq/${data.hqId}/order/setup`;

    navigate(`${url}?${params.toString()}`);
  }, [data, navigate, pageMode]);

  return <Spinner centered />;
};
